import React from "react";
import Layout from './Layout';
import TwoFA from '../../components/User/TwoFA'

export const TwoFAPage = () => <Layout><TwoFA></TwoFA></Layout> 
